import { useContext, useMemo } from "react";

import { Sidebar } from "../../../components/SharedComponents/Sidebar/Sidebar";
import { LoadingContent } from "../../../components/SharedComponents/sharedComponents.index";
import { LOADING_CONTENT_TYPE } from "../../../components/SharedComponents/LoadingContent/loading.content.constants";

import { LowTurnoverCard, ConcentrationCard, StockBreakCard, PurchaseOperationsTable } from "./purchaseQuality.index";

//import { usePurchaseQualityViewModel } from "../../../viewModel/usePurchaseQualityViewModel";
import { useOtbViewModel } from "../../../viewModel/useOtbVewModel";
import { useSeetingsViewModel } from "../../../viewModel/useSettingsViewModel";
import { TenantContext } from "../../../templates/context/TenantContext";

import { i18n } from "../../../translate/i18n";

export function PurchaseQuality() {

  const vm = useOtbViewModel({ shouldFetchInventoryDiagnosis: true });
  const settingsVm = useSeetingsViewModel({ shouldFetchUserCtx: true });
  const tenantContext = useContext(TenantContext) || {};

  const { updatedAt } = vm?.ctx?.inventoryDiagnosis?.summary || {};

  const lastUpdate = useMemo(() => {
    if (!updatedAt) return null;
    return new Date(updatedAt).toLocaleDateString(i18n.language, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "UTC",
    });
  }, [updatedAt]);

  if (vm?.uiState?.isLoadingInventoryDiagnosis)
    return <LoadingContent label={"Carregando dados..."} type={LOADING_CONTENT_TYPE.API_PAGE_DATA}/>

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar ctx={{ userRole: settingsVm?.ctx?.userRole, tenantContext }} />

      <div style={{ flex: 1, marginInlineStart: "64px", padding: "1rem 2.5rem 2rem" }}>

        <hgroup style={{ marginBlockStart: "1rem" }}>
          <h1 style={{ fontWeight: "bold", fontSize: "1.5rem", margin: 0 }}>
            Compra | Qualidade da Compra
          </h1>
          <p style={{ color: "#6B7280", fontSize: "0.85rem", margin: "4px 0 0 0" }}>
            Última atualização: {lastUpdate}
          </p>
        </hgroup>

        <section style={{ marginTop: "2rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1rem" }}>
            <div style={{ width: 5, height: 26, background: "#ED701D", borderRadius: 3 }} />
            <h2 style={{ fontWeight: "800", fontSize: "1.1rem", letterSpacing: "0.04em", color: "#1F2937", margin: 0 }}>
              DIAGNÓSTICO DO ESTOQUE
            </h2>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1.5rem" }}>
            <LowTurnoverCard ctx={{
              averagePercent: vm?.ctx?.lowTurnover?.averagePercent,
              stores: vm?.ctx?.lowTurnover?.stores,
              stoppedStockValue: vm?.ctx?.lowTurnover?.stoppedStockValue
            }} />

            <ConcentrationCard ctx={{ stores: vm?.ctx?.concentration?.stores }} />

            <StockBreakCard ctx={{
              generalAverage: vm?.ctx?.stockBreak?.avgBreakProductCount,
              totalEstimatedLoss: vm?.ctx?.stockBreak?.totalStockoutEstimatedLoss,
              stores: vm?.ctx?.stockBreak?.stores,
            }} />
          </div>
        </section>

        <section style={{ marginTop: "2rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1rem" }}>
            <div style={{ width: 5, height: 26, background: "#ED701D", borderRadius: 3 }} />
            <h2 style={{ fontWeight: "800", fontSize: "1.1rem", letterSpacing: "0.04em", color: "#1F2937", margin: 0 }}>
              OPERAÇÃO DE COMPRAS
            </h2>
          </div>
          <PurchaseOperationsTable stores={vm?.ctx?.purchaseOperation?.stores ?? []} />
        </section>

      </div>
    </div>
  );
}
